import React, { Component } from 'react'
import { Icon, message, Popover, Upload } from 'antd'

import './UploadWithPopupPreview.scss'

const API_URL = process.env.API_URL

export default class UploadWithPopupPreview extends Component {
    constructor(props) {
        super(props)
        this.state = { isUploading: false }

        this.onChange = this.onChange.bind(this)
        this.onRemove = this.onRemove.bind(this)
    }

    beforeUpload(file) {
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isImage) {
            message.error('You can only upload JPG/PNG file!')
        }
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!')
        }
        return isImage && isLt2M;
    }

    onChange(info) {
        const { itemImageChange } = this.props

        if (info.file.status === 'done') {
            this.setState({ isUploading: false })
            message.success(`${info.file.name} file uploaded successfully`)
            itemImageChange(info.file.response.url)
        } else if (info.file.status === 'error') {
            this.setState({ isUploading: false })
            message.error(`${info.file.name} file upload failed.`)
        } else if (info.file.status === 'uploading') {
            this.setState({ isUploading: true })
        }
    }

    onRemove() {
        const { itemImageChange } = this.props
        itemImageChange('')
    }

    render() {
        const { isLocked, itemImageChange, itemImageUrl, ...props } = this.props
        const { isUploading } = this.state

        const itemImage = (
            <img src={itemImageUrl} alt="" style={{ width: 100, height: 'auto' }}/>
        )

        if (isLocked) {
            if (!itemImageUrl)
                return null
            else
                return (
                    <div className="UploadWithPopupPreview">
                        <Popover content={itemImage} placement="top">
                            <Icon type="file" className="uploader-icon"/>
                        </Popover>
                    </div>
                )
        } else if (!itemImageUrl)
            return (
                <Upload
                    className="UploadWithPopupPreview"
                    showUploadList={false}
                    action={`${API_URL}/item`}
                    onChange={this.onChange}
                    beforeUpload={this.beforeUpload}
                    disabled={isUploading}
                    {...props}
                >
                    {
                        isUploading ?
                            <Icon type="loading" className="uploader-icon"/> :
                            <Icon type="plus" className="uploader-icon"/>
                    }
                </Upload>
            )
        else
            return (
                <div className="UploadWithPopupPreview">
                    <Popover content={itemImage} placement="top">
                        <Icon type="close" className="uploader-remove-icon" onClick={this.onRemove}/>
                    </Popover>
                </div>
            )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/UploadWithPopupPreview/UploadWithPopupPreview.js